export const isInDevEnv = (): boolean => {
  return process.env.DEVELOPMENT === "true";
};

export const isInProductionEnv = (): boolean => {
  return process.env.PRODUCTION === "true";
};
